!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.PageTitle = t(require("react")) : e.PageTitle = t(e.react);
}(window, function (e) {
  return function (e) {
    var t = {};

    function a(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, a), n.l = !0, n.exports;
    }

    return a.m = e, a.c = t, a.d = function (e, t, r) {
      a.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, a.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, a.t = function (e, t) {
      if (1 & t && (e = a(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (a.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        a.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return r;
    }, a.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return a.d(t, "a", t), t;
    }, a.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, a.p = "", a(a.s = 1);
  }([function (t, a) {
    t.exports = e;
  }, function (e, t, a) {
    "use strict";

    a.r(t);
    var r = a(0),
        n = a.n(r),
        l = {
      company: n.a.createElement("i", {
        className: "fal fa-building"
      }),
      site: n.a.createElement("i", {
        className: "fal fa-map-marker-alt"
      }),
      gate: n.a.createElement("i", {
        className: "fal fa-door-open"
      }),
      user: n.a.createElement("i", {
        className: "fal fa-users"
      }),
      blocklist: n.a.createElement("i", {
        className: "fal fa-hand-paper"
      }),
      muster: n.a.createElement("i", {
        className: "fal fa-exclamation-triangle"
      }),
      profile: n.a.createElement("i", {
        className: "fal fa-user-circle"
      }),
      support: n.a.createElement("i", {
        className: "fal fa-question-circle"
      }),
      signout: n.a.createElement("i", {
        className: "fal fa-sign-out-alt"
      })
    };

    t.default = function (e) {
      var t = e.icon,
          a = (e.edit, e.editLink),
          r = e.children,
          o = l[t];
      return n.a.createElement("div", {
        className: "flex flex-row"
      }, n.a.createElement("div", {
        className: "text-orange-500 mr-2 text-2xl"
      }, o), n.a.createElement("div", {
        className: "text-gray-900 mr-4 text-2xl"
      }, r), void 0 === a ? null : n.a.createElement("a", {
        className: "self-center mt-1 underline",
        href: a
      }, "Edit"));
    };
  }]);
});